import { render } from "./PaymentConfirmation.vue?vue&type=template&id=0277846a&scoped=true"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=js"

import "./PaymentConfirmation.vue?vue&type=style&index=0&id=0277846a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0277846a"]])

export default __exports__